import type { ImmutableArray } from "shelving";
import { DATA, StringSchema, getWords, simplifyString } from "shelving";
import { Form, Icon, SubmitButton, TextField } from "shared/react";

const FILTER_SCHEMA = DATA({
	query: new StringSchema({ title: "Filter", placeholder: `e.g. canoeing` }),
});

/** Form that allows filtering of content by a query string. */
export function FilterForm({ onFilter }: { onFilter: (words: ImmutableArray<string>) => void }): React.ReactElement {
	return (
		<Form schema={FILTER_SCHEMA} onSubmit={({ query }) => onFilter(getWords(query).map(simplifyString))} mods="flex-row">
			<TextField name="query" title="" />
			<SubmitButton mods="flex-fit button-default">
				<Icon icon="search" title="Filter" />
			</SubmitButton>
		</Form>
	);
}
